module.exports = __webpack_public_path__ + "img/ligu.9c0e858c.jpg";